import React, { useState, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addSystemsExpereinceScoringAction,
    updateSystemsExpereinceScoringAction,
    deleteSystemsExpereinceScoringAction
} from '../../../redux/actions/admin/adminAction';

export const SystemExperience = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'experience': '', 'score': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'experience': '', 'score': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateSystemExperience(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addSystemExperience(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteSystemExperience(id)
    }


    const [systemExperienceColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Experience", field: 'experience', filter: true },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.systemExpereineScoring}
                defaultColDef={defaultColDef}
                columnDefs={systemExperienceColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>System Experience</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>System Experience</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="experience"
                                name="experience"
                                value={inputData.experience}
                                onChange={handleChange}
                                placeholder="Experience"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Score</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="score"
                                name="score"
                                value={inputData.score}
                                onChange={handleChange}
                                placeholder="Score"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const systemExpereineScoring = state.admin.systemExpereineScoring;
    return {
        systemExpereineScoring: systemExpereineScoring,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addSystemExperience: (data) => dispatch(addSystemsExpereinceScoringAction(data)),
        updateSystemExperience: (id, data) => dispatch(updateSystemsExpereinceScoringAction(id, data)),
        deleteSystemExperience: (id) => dispatch(deleteSystemsExpereinceScoringAction(id)),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemExperience)
